import React, { useState } from "react";
import { FaEdit } from "react-icons/fa";
import { useEditDealerMutation } from "../../../features/api/dealerApi";
import { toast } from "react-toastify";

const UpdateDealer = ({ dealer }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [d_name, setName] = useState("");
  const [d_email, setEmail] = useState("");
  const [d_address, setAddress] = useState("");
  const [d_addressing, setAddressing] = useState("");
  const [d_phone, setPhone] = useState("");
  const [d_mobile, setMobile] = useState("");
  const [d_web, setWeb] = useState("");

  const [updateDealer] = useEditDealerMutation();
  const handleUpdate = async (id) => {
    try {
      const data = {
        id: id,
        d_name: d_name ? d_name : dealer?.d_name,
        d_email: d_email ? d_email : dealer?.d_email,
        d_address: d_address ? d_address : dealer?.d_address,
        d_addressing: d_addressing ? d_addressing : dealer?.d_addressing,
        d_phone: d_phone ? d_phone : dealer?.d_phone,
        d_mobile: d_mobile ? d_mobile : dealer?.d_mobile,
        d_web: d_web ? d_web : dealer?.d_web,
      };
      const response = await updateDealer(data);
      if (!response) {
        toast.error("Error occurd...");
      } else {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        toast.success("Update Success");
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };
  return (
    <div>
      <span onClick={openModal}>
        <FaEdit className="text-xl text-blue-500 font-bold cursor-pointer" />
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-md md:w-[650px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <div className="card-body">
                <div className="text-center">
                  <h2 className=" font-bold">Update</h2>
                </div>
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-1 lg:gap-2 w-full">
                    <div className="flex justify-between">
                      <label className="mr-5 font-bold">Name:</label>
                      <input
                        type="text"
                        defaultValue={dealer?.d_name}
                        onChange={(e) => setName(e.target.value)}
                        className="border pl-1 w-full"
                      />
                    </div>
                    <div className="flex justify-between">
                      <label className="mr-5 font-bold">Email:</label>
                      <input
                        type="text"
                        defaultValue={dealer?.d_email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="border pl-1 w-full"
                      />
                    </div>
                    <div className="flex justify-between">
                      <label className="mr-4 font-bold">Phone:</label>
                      <input
                        type="text"
                        defaultValue={dealer?.d_phone}
                        onChange={(e) => setPhone(e.target.value)}
                        className="border pl-1 w-full"
                      />
                    </div>
                    <div className="flex justify-between">
                      <label className="mr-3 font-bold">Mobile:</label>
                      <input
                        type="text"
                        defaultValue={dealer?.d_mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        className="border pl-1 w-full"
                      />
                    </div>
                    <div className="flex justify-between">
                      <label className="mr-2 font-bold">Website:</label>
                      <input
                        type="text"
                        defaultValue={dealer?.d_web}
                        onChange={(e) => setWeb(e.target.value)}
                        className="border pl-1 w-full"
                      />
                    </div>
                  </div>
                  <div className="mt-2 w-full">
                    <div className="flex justify-between mb-2">
                      <label className="mr-1 font-bold">Address:</label>
                      <input
                        type="text"
                        defaultValue={dealer?.d_address}
                        onChange={(e) => setAddress(e.target.value)}
                        className="border pl-1 w-full"
                      />
                    </div>
                    <div className="flex justify-between">
                      <label className="mr-1 font-bold">Addressing:</label>
                      <input
                        type="text"
                        defaultValue={dealer?.d_addressing}
                        onChange={(e) => setAddressing(e.target.value)}
                        className="border pl-1 w-full"
                      />
                    </div>
                  </div>
                  <button
                    onClick={() => handleUpdate(dealer?.id)}
                    className="bg-green-500 text-white font-bold mt-6 px-4 block m-auto"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateDealer;
